<!--  -->
<template>
<div>
     <div class="layout-content" style="background: transparent;">
      <div  v-if="list.length">
        <Table ref="selection" :columns="columns" :data="list">
          <template slot-scope="{ row }" slot="sourceLinkTypeStr">{{row.sourceLinkTypeStr}}</template>
          <template slot-scope="{ row }" slot="sourceIdCount">{{row.sourceLinkTypeCount}}</template>
        </Table>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
data() {
return {
    columns: [
        {
          title: "点击页面",
          slot: "sourceLinkTypeStr",
          align: "center",
          //width: 240
        },
        {
          title: "数量",
          slot: "sourceIdCount",
          align: "center",
          //width: 240
        }
      ],
      list: [],
      pageSize:10,
      pageIndex:1,
      totalCount:""
}
},
//生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
     
      getCategoryContent: "hostCommonModule/getCategoryContent"
    }),
    async init() {
    let opt={
   
//     "pageSize": this.pageSize,
//     "pageIndex": this.pageIndex,
    }
      let data=await this.getCategoryContent(opt)
      console.log(data,'查询的数据');
      let tolcontent=0
      if(data&&data.items&&data.items.length>0){
          data.items.forEach(e=>{
              tolcontent+=e.sourceLinkTypeCount
          })
          data.items.push({
              sourceLinkTypeStr:'总数',
              sourceLinkTypeCount:tolcontent
              
          })
          this.list=data.items
      }
      
    },

    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
  }

}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */

</style>